export default {
	mounted(el) {
		let isDown = false;
		let startX;
		let scrollLeft;
		let hasDragged = false;

		el.style.cursor = 'grab';
		el.style.scrollbarWidth = 'none';
		el.style.msOverflowStyle = 'none';
		
		const styleTag = document.createElement('style');
		styleTag.textContent = `
			[data-drag-scroll]::-webkit-scrollbar {
				display: none;
			}
		`;
		if (!document.querySelector('[data-drag-scroll-style]')) {
			styleTag.setAttribute('data-drag-scroll-style', '');
			document.head.appendChild(styleTag);
		}
		el.setAttribute('data-drag-scroll', '');

		const handleMouseDown = (e) => {
			isDown = true;
			hasDragged = false;
			startX = e.pageX - el.offsetLeft;
			scrollLeft = el.scrollLeft;
			el.style.cursor = 'grabbing';
			el.style.userSelect = 'none';
		};

		const handleMouseLeave = () => {
			if (isDown) {
				isDown = false;
				el.style.cursor = 'grab';
				el.style.userSelect = '';
			}
		};

		const handleMouseUp = () => {
			isDown = false;
			el.style.cursor = 'grab';
			el.style.userSelect = '';

			if (hasDragged) {
				setTimeout(() => {
					hasDragged = false;
				}, 10);
			}
		};

		const handleMouseMove = (e) => {
			if (!isDown) return;
			e.preventDefault();

			const x = e.pageX - el.offsetLeft;
			const walk = (x - startX) * 2;

			if (Math.abs(walk) > 5) {
				hasDragged = true;
			}

			el.scrollLeft = scrollLeft - walk;
		};

		const handleClick = (e) => {
			if (hasDragged) {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		el.addEventListener('mousedown', handleMouseDown);
		el.addEventListener('mouseleave', handleMouseLeave);
		el.addEventListener('mouseup', handleMouseUp);
		el.addEventListener('mousemove', handleMouseMove);
		el.addEventListener('click', handleClick, true);

		el._dragScrollCleanup = () => {
			el.removeEventListener('mousedown', handleMouseDown);
			el.removeEventListener('mouseleave', handleMouseLeave);
			el.removeEventListener('mouseup', handleMouseUp);
			el.removeEventListener('mousemove', handleMouseMove);
			el.removeEventListener('click', handleClick, true);
		};
	},

	unmounted(el) {
		if (el._dragScrollCleanup) {
			el._dragScrollCleanup();
		}
	},
};
